import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-slider.css';

var getClassNameList = classNames.bind(styles);
var UitkSliderInput = function (props) {
    var absoluteMax = props.absoluteMax, absoluteMin = props.absoluteMin, disabled = props.disabled, formatValueForDisplay = props.formatValueForDisplay, gap = props.gap, handleAfterChange = props.handleAfterChange, handleChange = props.handleChange, id = props.id, isActive = props.isActive, label = props.label, lowerValue = props.lowerValue, max = props.max, min = props.min, name = props.name, onActive = props.onActive, step = props.step, type = props.type, upperValue = props.upperValue, value = props.value, minDistance = props.minDistance;
    var _a = React.useState(false), mounted = _a[0], setMounted = _a[1];
    React.useEffect(function () {
        setMounted(true);
    }, []);
    var changeEventEmitter = function (changeCb, event) {
        // Fallbacks provided for linter
        var newMaxValue = max || absoluteMax;
        var newMinValue = min || absoluteMin;
        var innerValue = event && event.target && event.target.value;
        var parsed = (innerValue && parseInt(innerValue, 10));
        switch (type) {
            case 'primary':
                if (newMaxValue - Math.min(newMaxValue - gap, parsed) >= minDistance) {
                    changeCb(Math.min(newMaxValue - gap, parsed), newMaxValue, event);
                }
                break;
            case 'secondary':
                if (Math.max(newMinValue + gap, parsed) - newMinValue >= minDistance) {
                    changeCb(newMinValue, Math.max(newMinValue + gap, parsed), event);
                }
                break;
            default:
                changeCb(parsed);
                break;
        }
    };
    var handleChangeEvt = function (event) {
        if (typeof onActive === 'function') {
            onActive(type);
        }
        if (typeof handleChange === 'function') {
            changeEventEmitter(handleChange, event);
        }
    };
    var handleAfterChangeEvt = function (event) {
        if (typeof handleAfterChange === 'function') {
            changeEventEmitter(handleAfterChange, event);
        }
    };
    var outputRef = React.createRef();
    var thumbPosition;
    var inputClasses = ['uitk-slider-input'];
    var outputClasses = ['uitk-slider-output'];
    var inputStyles = {};
    var sliderStyles = {};
    var componentId = "".concat(id, "-").concat(type);
    // Fallbacks provided for linter
    var maxValue = max !== null && max !== void 0 ? max : absoluteMax;
    var minValue = min !== null && min !== void 0 ? min : absoluteMin;
    var newLowerValue = lowerValue !== null && lowerValue !== void 0 ? lowerValue : absoluteMin;
    var newUpperValue = upperValue !== null && upperValue !== void 0 ? upperValue : absoluteMax;
    var newValue = value !== null && value !== void 0 ? value : absoluteMin;
    if (isActive) {
        inputClasses.push('uitk-slider-input-active');
    }
    switch (type) {
        case 'primary':
            inputClasses.push('slider-primary');
            thumbPosition = 100 / ((maxValue - absoluteMin) / (newLowerValue - absoluteMin));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 0;
            }
            inputStyles['--slider-primary'] = "".concat(thumbPosition, "%");
            sliderStyles.width = "".concat((100 / (absoluteMax - absoluteMin)) * (newUpperValue - absoluteMin), "%");
            break;
        case 'secondary':
            inputClasses.push('slider-secondary');
            thumbPosition = 100 - 100 / ((maxValue - minValue) / (maxValue - newUpperValue));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 100;
            }
            inputStyles['--slider-secondary'] = "".concat(thumbPosition, "%");
            sliderStyles.width = "".concat(100 - (100 / (absoluteMax - absoluteMin)) * (newLowerValue - absoluteMin), "%");
            break;
        default:
            inputClasses.push('slider-single', 'slider-primary');
            thumbPosition = 100 / ((maxValue - minValue) / (newValue - minValue));
            if (!isFinite(thumbPosition)) {
                thumbPosition = 0;
            }
            inputStyles['--slider-primary'] = "".concat(thumbPosition, "%");
            sliderStyles.width = '100%';
            break;
    }
    var valueToDisplay = typeof formatValueForDisplay === 'function' ? formatValueForDisplay(newValue) : newValue;
    var baseInputAttrs = {
        'aria-label': label || name,
        'aria-valuetext': "".concat(valueToDisplay),
        className: getClassNameList(inputClasses),
        disabled: disabled,
        id: componentId,
        max: maxValue,
        min: minValue,
        name: name,
        onChange: handleChangeEvt,
        onKeyUp: handleAfterChangeEvt,
        onMouseUp: handleAfterChangeEvt,
        onTouchEnd: handleAfterChangeEvt,
        step: step,
        style: inputStyles
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: getClassNameList('uitk-slider'), style: sliderStyles },
            mounted ? (React.createElement(React.Fragment, null,
                React.createElement("input", __assign({ type: "range", "aria-valuemax": maxValue, "aria-valuemin": minValue, "aria-valuenow": newValue, value: newValue }, baseInputAttrs)))) : (
            // eslint-disable-next-line jsx-a11y/role-supports-aria-props
            React.createElement("input", __assign({ type: "number", "aria-valuemax": maxValue, "aria-valuemin": minValue, "aria-valuenow": newValue, value: newValue }, baseInputAttrs))),
            React.createElement("label", { className: "is-hidden", htmlFor: componentId }, label || name)),
        React.createElement("span", { className: getClassNameList(outputClasses), ref: outputRef, "aria-hidden": "true" }, valueToDisplay)));
};
UitkSliderInput.displayName = 'UitkSliderInput';

export { UitkSliderInput };
